import { F0Box, F0Checkbox, F0Text } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

type Mode = 'schedule' | 'launch'

interface ModeOptionCardProps {
  mode: Mode
  selectedMode: Mode
  label: string
  onSelect: (mode: Mode) => void
}

const ModeOptionCard = ({ mode, selectedMode, label, onSelect }: ModeOptionCardProps) => {
  const isSelected = selectedMode === mode

  return (
    <button
      type="button"
      onClick={() => onSelect(mode)}
      style={{
        padding: 0,
        width: '100%',
        border: 'none',
        cursor: 'pointer',
        background: 'transparent',
      }}
    >
      <F0Box
        width="full"
        padding="md"
        display="flex"
        border="default"
        borderRadius="md"
        alignItems="center"
        justifyContent="between"
        background={isSelected ? 'selected' : 'primary'}
        borderColor={isSelected ? 'selected' : 'default'}
      >
        <F0Text variant="label" content={label} />
        {isSelected && (
          <F0Checkbox
            hideLabel
            title={label}
            checked={isSelected}
            onCheckedChange={() => onSelect(mode)}
          />
        )}
      </F0Box>
    </button>
  )
}

interface SubmissionPeriodModeSelectorProps {
  value: Mode
  onChange: (mode: Mode) => void
  canLaunchNow?: boolean
}

const SubmissionPeriodModeSelector = ({
  value,
  onChange,
  canLaunchNow = true,
}: SubmissionPeriodModeSelectorProps) => {
  return (
    <F0Box display="flex" gap="sm">
      <ModeOptionCard
        mode="schedule"
        onSelect={onChange}
        selectedMode={value}
        label={i18n.t('planning.submission_period.form.schedule_for_later')}
      />

      {canLaunchNow && (
        <ModeOptionCard
          mode="launch"
          onSelect={onChange}
          selectedMode={value}
          label={i18n.t('planning.submission_period.form.launch_now')}
        />
      )}
    </F0Box>
  )
}

export default SubmissionPeriodModeSelector
